export default "__VITE_ASSET__NyR8Z92___"